import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { getValidationForCodeType } from '../../model/consts/product-identifier-validation.const';

@Pipe({
  name: 'customErrorsText',
})
export class CustomErrorsTextPipe implements PipeTransform {
  transform(_: any, item: UntypedFormGroup): string {
    const codeType = item?.get('typeProdIdentifiers')?.value;
    const validationData = getValidationForCodeType(codeType);
    return validationData ? validationData.errorText : null;
  }
}
